import styled from 'styled-components';
import { IC_PENDING_RED } from '../../../../Assets/images';

export const SquareImageUploadStyled = styled.div`
  position: relative;
  > .label {
    font-weight: 600;
    font-size: 16px;
  }
  .text-title {
    font-size: 15px;
    color: ${(props) => props.theme.text.medium};
    margin-left: 17px;
  }
  .text-sub-title {
    font-size: 13px;
    color: ${(props) => props.theme.text.medium};
  }
  .text-or-title {
    font-size: 13px;
    color: ${(props) => props.theme.text.dark};
  }
  .link-sub-title {
    font-size: 13px;
    color: ${(props) => props.theme.blue.dark};
    text-decoration: underline;
  }

  .upload-wrapper {
    position: relative;
    min-height: 226px;
    display: flex;
    align-items: center;
    border: 2px solid ${(props) => props.theme.color.border};
    border-radius: 8px;
    border-style: dashed;
    justify-content: center;

    &.error {
      border-color: ${(props) => props.theme.verification.red.main};
    }
  }
  .trash-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
  }

  .upload-image {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .defaultTitle {
      text-align: center;
    }
  }
  .file-upload {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    z-index: 1;
  }

  .invalid-feedback {
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.verification.red.main};
  }
  .image-border-radius {
    border-radius: 8px;
  }
`;
